import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';

import classNames from 'classnames';
import styles from './field-template.css';

const { div, label } = hh(h);

const FieldTemplate = (props) => {
    const labelElement = label(
        {
            className: classNames(
                styles.label,
                {
                    [styles.required]: R.equals(props.required, true)
                }),
            htmlFor: props.id
        },
        props.label
    );

    return (
        div({className: styles.container}, R.reject(R.isNil, [
            props.displayLabel ? labelElement : null,
            props.children,
            div({className: styles.errors}, props.errors),
            div({className: styles.help}, props.help)]))
    );
};

export default FieldTemplate;



/** WEBPACK FOOTER **
 ** ./src/ApplicationForm/FieldTemplate.js
 **/